const educationDegreeTypeOptions = [
  { value: 'phd', displayValue: 'PhD' },
  { value: 'masters', displayValue: "Master's" },
  { value: 'bachelors', displayValue: "Bachelor's" },
  { value: 'associate', displayValue: 'Associate' },
  { value: 'other', displayValue: 'Other' },
];

export default educationDegreeTypeOptions;
